import React from 'react';

const FaleConosco = () => {
    return <div>Fale conosco</div>;
};

export default FaleConosco;
